import * as React from 'react';
import { Modal } from 'antd';

import Form, { FormItem } from '../../../../../../components/Form';
import PriceInput from '../../../../../../components/Others/PriceInput';
import { exportRawPriceObject } from '../../../../../../helpers/Prices/exportRawPriceObject';

export interface IInsuranceLimitDetailProps {
  limit: GQL.IDeliveryMethodInsuranceLimit;
  currency: GQL.ICurrency;
  onSave: (limit: GQL.IDeliveryMethodInsuranceLimit) => void;
  onCancel: () => void;
}

export interface IInsuranceLimitDetailState {
  limit: GQL.IDeliveryMethodInsuranceLimit;
}

export default class InsuranceLimitDetail extends React.Component<IInsuranceLimitDetailProps, IInsuranceLimitDetailState> {

  constructor(props: IInsuranceLimitDetailProps) {
    super(props);

    this.state = {
      limit: props.limit ? {...props.limit} : {} as GQL.IDeliveryMethodInsuranceLimit,
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { limit } = this.state;

    return (
      <Modal
        maskClosable={false}
        style={{ top: '5vh' }}
        title={`Limit for insurance`}
        visible={true}
        footer={null}
        onCancel={() => this.props.onCancel()}
      >
        <Form 
          onSubmit={this.save}
          onCancel={() => this.props.onCancel()}
        >
          <FormItem label={`For orders with price from (excl. VAT)`}>
            <PriceInput
              name={'fromPriceOrder'}
              mode={'priceWithout'}
              prices={limit && limit.fromPriceOrder 
                ? limit.fromPriceOrder.map((price: GQL.IPrice) => ({ 
                    currencyId: price.currencyId, 
                    priceWithout: price.priceWithout
                  }))
                : []}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label={`For orders with price to (excl. VAT)`}>
            <PriceInput
              name={'toPriceOrder'}
              mode={'priceWithout'}
              prices={limit && limit.toPriceOrder 
                ? limit.toPriceOrder.map((price: GQL.IPrice) => ({ 
                    currencyId: price.currencyId, 
                    priceWithout: price.priceWithout
                  }))
                : []}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label={`Price (excl. VAT)`} required={true}>
            <PriceInput
              mode={'priceWithout'}
              name={'prices'}
              prices={limit && limit.prices ? limit.prices.map((price: GQL.IPrice) => ({ 
                currencyId: price.currencyId, 
                priceWithout: price.priceWithout
              })) : []}
              onChange={this.onChange}
            />
          </FormItem>
        </Form>
      </Modal>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.limit[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      limit: { ...this.state.limit, ...newValue }
    });
  }

  private save() {
    const limit = {
      ...this.state.limit,
      prices: this.state.limit.prices.map((price: GQL.IPrice) => {
        return exportRawPriceObject(price);
      })
    };
    this.props.onSave(limit as GQL.IDeliveryMethodInsuranceLimit);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/Insurance/components/InsuranceLimitDetail.tsx